import "$styles/index.css"

// Projects index filter (progressive enhancement)
import './project-filter.js'

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// FAQ accordion — progressive enhancement: auto-close other items
document.addEventListener('DOMContentLoaded', () => {
  const faq = document.getElementById('faq')
  if (!faq) return
  faq.querySelectorAll('details').forEach(detail => {
    detail.addEventListener('toggle', () => {
      if (!detail.open) return
      faq.querySelectorAll('details[open]').forEach(other => {
        if (other !== detail) other.open = false
      })
    })
  })
})

console.info("Bridgetown is loaded!")
